import { T, F, always } from 'ramda';

export const requestEvolve = {
  pending: T,
  error: F
};

export const failEvolve = (error) => ({
  pending: F,
  error: always(error)
});

export const successEvolve = {
  pending: F,
  error: F
};